import React, {Component} from 'react';
import FuseTheme from '../global/theme';

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontSize: '1.015em',
        fontWeight: '400',
        margin: 0,
        padding: '0.15em 0.5em'
    },
    wrapText: {wordWrap: 'break-word'},
    row: {
        display: 'flex',
        width: '100%',
        borderBottom: '1px solid rgb(117, 117, 117)',
    },
    rowTitle: {
        flex: 1,
        fontSize: '0.975em',
        fontWeight: 600,
        padding: '0.5em 1em',
        borderRight: '1px solid rgb(117, 117, 117)'
    },
    rowValue: {
        fontSize: '0.975em',
        flex: 2,
        textAlign: 'right',
        padding: '0.5em 1em'
    }
};

class DialogSalesTaxAuditDetail extends Component {

    renderDetailRows = (list) => {
        if (!list || list.length === 0) {
            return null;
        }
        return (
            list.map((item, index) => (
                <div style={styles.row} key={`${item.name}-${index}`}>
                    <div style={styles.rowTitle}>{item.name}</div>
                    <div style={styles.rowValue}>{item.tax_rate}%</div>
                    <div style={styles.rowValue}>{item.amount_formatted}</div>
                </div>
            ))
        );
    };

    render() {
        const {
            data
        } = this.props;

        return (
            <div className="reports-custom-table-container">
                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Tax Detail for Location {data.location_id}</span>
                    </h3>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>&nbsp;</div>
                    <div style={styles.rowValue}>Rate</div>
                    <div style={styles.rowValue}>Amount</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Tax Rate</div>
                    <div style={styles.rowValue}>{data.tax_rate}</div>
                    <div style={styles.rowValue}>{data.baseTax}</div>
                </div>
                {[...this.renderDetailRows(data.additional_taxes)]}
                <div style={styles.row}>
                    <div style={styles.rowTitle}></div>
                    <div style={styles.rowValue}>{data.total_tax_rate}</div>
                    <div style={styles.rowValue}>{data.salesTax}</div>
                </div>
            </div>
        );
    }
}

export default DialogSalesTaxAuditDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogSalesTaxAuditDetail.js